import { useQuery, useQueryClient } from '@tanstack/react-query'
import FieldValue from '../field_value'
import { Status } from '@bitcine/cinesend-theme/dist'

const FieldsByLanguage = ({ assetID, languageID, cycleID }) => {
  const queryClient = useQueryClient()
  const queryKey = [`field-values`, `?assetID=${assetID}`, `&languageID=${languageID}`, `&cycleID=${cycleID}`]
  const { data: fields, isInitialLoading, isError, error } = useQuery(queryKey)
  const refreshValues = () => queryClient.invalidateQueries(queryKey)

  return (
    <Status pending={isInitialLoading} isError={isError} errorMessage={error?.message}>
      <div className='space-y-4'>
        {fields?.map((field, index) => (
          <FieldValue
            cacheKey={queryKey}
            key={index}
            field={field}
            isLoading={isInitialLoading}
            assetID={assetID}
            cycleID={cycleID}
            languageID={languageID}
            refreshValues={() => refreshValues()}
          />
        ))}
      </div>
    </Status>
  )
}

export default FieldsByLanguage
